<template>
  <el-form ref="form" label-width="200px" :model="{}" :rules="rules">
    <el-form-item label="计划位置">
      <RadioGroup v-model="creativeForm.scene" type="button" @on-change="changScene">
        <Radio :label="1" :disabled="creativeForm.union">优选流量</Radio>
        <Radio :label="2" :disabled="creativeForm.union">按场景选择计划位</Radio>
        <Radio :label="4" :disabled="!creativeForm.union">百青藤</Radio>
      </RadioGroup>
    </el-form-item>
    <el-form-item label="" v-if="creativeForm.scene === 2" prop="ftypes">
      <CheckboxGroup v-model="creativeForm.ftypes" @on-change="changeFtypes">
        <Checkbox :label="1">百度信息流</Checkbox>
        <Checkbox :label="2">贴吧信息流</Checkbox>
        <Checkbox :label="8">好看视频</Checkbox>
        <Checkbox :label="64">百度小说</Checkbox>
      </CheckboxGroup>
    </el-form-item>
    <el-form-item label="投放版位">
      <Mixcheck v-model="creativeForm.producttypes">
        <Radio-item :label="0">默认</Radio-item>
        <Check-item :label="1" :disabled="disabledptype">列表页</Check-item>
      </Mixcheck>
    </el-form-item>
    <el-form-item label="创意形式">
      <RadioGroup v-model="creativeForm.ideaType" type="button">
        <Radio :label="1">程序化</Radio>
      </RadioGroup>
    </el-form-item>
    <el-form-item label="创意素材" prop="creatives">
      <RadioGroup v-model="creativeForm.image_mode" type="button">
        <Radio label="CREATIVE_IMAGE_MODE_VIDEO"
          >视频 {{ creativeForm.videoCreative && creativeForm.videoCreative.length ? `(${creativeForm.videoCreative.length})` : '' }}</Radio
        >
        <Radio label="CREATIVE_IMAGE_MODE_LARGE"
          >大图 {{ creativeForm.largeCreative && creativeForm.largeCreative.length ? `(${creativeForm.largeCreative.length})` : '' }}</Radio
        >
        <Radio label="CREATIVE_IMAGE_MODE_SMALL"
          >小图 {{ creativeForm.imageCreative && creativeForm.imageCreative.length ? `(${creativeForm.imageCreative.length})` : '' }}</Radio
        >
        <Radio label="CREATIVE_IMAGE_MODE_GROUP"
          >组图 {{ creativeForm.groupCreative && creativeForm.groupCreative.length ? `(${creativeForm.groupCreative.length})` : '' }}</Radio
        >
      </RadioGroup>
    </el-form-item>
    <!-- 视频 -->
    <el-form-item v-if="creativeForm.image_mode === 'CREATIVE_IMAGE_MODE_VIDEO'">
      <div style="display: flex">
        <Button
          v-if="creativeForm.videoCreative.length < 6"
          type="default"
          icon="md-add"
          @click="addCreative('video')"
          class="add-btn"
        ></Button>
        <creative
          type="video"
          :data="creativeForm.videoCreative"
          :source="creativeForm.creativeDetails"
          :local="false"
          :verify="verify"
          @on-select="selectImage"
          @on-delete="deleteItem"
        />
      </div>
    </el-form-item>
    <!-- 大图 -->
    <el-form-item v-if="creativeForm.image_mode === 'CREATIVE_IMAGE_MODE_LARGE'">
      <div style="display: flex">
        <Button
          v-if="creativeForm.largeCreative.length < 6"
          type="default"
          icon="md-add"
          @click="addCreative('large')"
          class="add-btn"
        ></Button>
        <creative
          type="large"
          :data="creativeForm.largeCreative"
          :source="creativeForm.creativeDetails"
          :local="false"
          :verify="verify"
          @on-select="selectImage"
          @on-delete="deleteItem"
        />
      </div>
    </el-form-item>
    <!-- 小图 -->
    <el-form-item v-if="creativeForm.image_mode === 'CREATIVE_IMAGE_MODE_SMALL'">
      <div style="display: flex">
        <Button
          v-if="creativeForm.imageCreative.length < 6"
          type="default"
          icon="md-add"
          @click="addCreative('image')"
          class="add-btn"
        ></Button>
        <creative
          type="image"
          :data="creativeForm.imageCreative"
          :source="creativeForm.creativeDetails"
          :local="false"
          :verify="verify"
          @on-select="selectImage"
          @on-delete="deleteItem"
        />
      </div>
    </el-form-item>
    <!-- 组图 -->
    <el-form-item v-if="creativeForm.image_mode === 'CREATIVE_IMAGE_MODE_GROUP'">
      <div style="display: flex">
        <Button
          v-if="creativeForm.groupCreative.length < 6"
          type="default"
          icon="md-add"
          @click="addCreative('group')"
          class="add-btn"
        ></Button>
        <creative
          type="group"
          :data="creativeForm.groupCreative"
          :source="creativeForm.creativeDetails"
          :local="false"
          :verify="verify"
          @on-select="selectImage"
          @on-delete="deleteItem"
        />
      </div>
    </el-form-item>
    <el-form-item label="标题" prop="title">
      <select-title
        v-model="creativeForm.titleList"
        :words="[]"
        :max="6"
        :open-id="opId"
        @on-append="addTitleList"
        @on-delete="delTitleList"
      />
    </el-form-item>
    <el-form-item label="副标题" v-if="creativeForm.materialstyle === 113" prop="subtitle">
      <input-len v-model="creativeForm.subtitle" placeholder="最大24个字符，1个中文等于2个字符" width="480" :max="24" />
    </el-form-item>
    <el-form-item label="落地页URL" v-else>
      <Input readonly placeholder="内部计划自动生成" style="width: 480px" disabled />
    </el-form-item>
    <el-form-item label="品牌名称" prop="brand">
      <input-len v-model="creativeForm.brand" charset="init" placeholder="最大11个字符，1个中文等于2个字符" width="480" :max="11" />
    </el-form-item>
    <el-form-item label="品牌头像" prop="userPortrait">
      <cardptom-icon
        :value="creativeForm.userPortrait"
        :width="120"
        :file-size="1024"
        :local="false"
        :sources="creativeForm.creativeDetails"
        @on-select="addCreative('logo')"
      />
    </el-form-item>

    <el-dialog
      :visible.sync="showSelectorModal"
      custom-class="material-selector-dialog"
      :close-on-click-modal="false"
      title="选择素材"
      width="1200px"
      append-to-body
      @close="onSelectorClose"
    >
      <AssetsSelector
        v-bind="{ ...selectorProps, visible: showSelectorModal, selectedGameId: gameId }"
        @close="onSelectorClose"
        @confirm="uploadFileHandle"
      >
        <template v-slot:assetType="{ getData }">
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.VIDEO]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO]"
          >
            视频
          </el-radio>
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.IMAGE]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]"
          >
            图片
          </el-radio>
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled.cover"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.POSTER]"
          >
            封面
          </el-radio>
        </template>

        <template v-slot:sizes="{ getData, width }">
          <el-select
            :style="{ width }"
            popper-class="creative-selector-el-select-popper"
            :popper-append-to-body="false"
            v-model="selectorProps.form.size"
            @change="getData"
          >
            <!-- 根据当前选择素材的类型来获取尺寸下拉数据 -->
            <el-option
              v-for="item in MATERIAL_TYPE_SIZES[selectorProps.assetType]"
              :key="item.label"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </template>
      </AssetsSelector>
    </el-dialog>
  </el-form>
</template>
<script>
import { getSession } from '@/common/js/api'
import { MEDIAS } from '@/common/js/constants.js'
import { isArray, deepCopy } from '@/common/js/utils'
import { adAccount, adGames, getSysTag, getCaoHuaOpenIds } from '@/api/common.model'
import { getPtomGroupGames } from '@/api/material.model'
import { makeCreativeRules } from './data/form-rules.js'
import InputLen from '@/components/input/input-len'
import Mixcheck from '@/components/mixcheck'
import CheckItem from '@/components/mixcheck/check-item'
import RadioItem from '@/components/mixcheck/radio-item'
import Creative from './components/idea/creative/creative.vue'
// import Uploader from './components/idea/media/uploader.vue'
import SelectTitle from './components/idea/media/select-title.vue'
import CardptomIcon from '@/components/cardptom/'
import creativeTemplate from '@/data/baidu/creative.json'

import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'
import { AssetsSelector, makeSelectorForm } from '@/components/material-selector/index.js'

export default {
  components: {
    Mixcheck,
    CheckItem,
    RadioItem,
    Creative,
    // Uploader,
    SelectTitle,
    InputLen,
    CardptomIcon,
    AssetsSelector
  },
  data() {
    return {
      MATERIAL_TYPE_ID,
      MATERIAL_TYPE,
      MATERIAL_TYPE_SIZES: {
        [MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO]]: [
          { label: '1280*720' },
          { label: '720*1280' },
          { label: '1920*1080' },
          { label: '1080*1920' }
        ],
        [MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]]: [
          { label: '1140*640' },
          { label: '370*245' },
          { label: '1920*1080' },
          { label: '1080*1920' }
        ],
        [MATERIAL_TYPE_ID[MATERIAL_TYPE.POSTER]]: []
      },
      showSelectorModal: false,
      selectorProps: {
        max: 1,
        assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO],
        form: { ...makeSelectorForm(), size: '1280*720', media_id: MEDIAS.BAIDU }
      },
      rules: { ...makeCreativeRules.call(this) },
      gameData: [],
      agentData: [],
      dynpos: [],
      verify: false,
      uploadModel: false,
      uploadType: '', // 上传类型
      uploadName: '',
      uploadSmart: 0, // 智能封面视频ID
      uploadWidth: 0,
      uploadHeight: 0,
      uploadSize: 0,
      uploadMult: 1,
      uploadIndex: null,
      uploadBatch: null,
      gameGroupData: [],
      labelData: [],
      operatorData: [],
      creativeElements: creativeTemplate
    }
  },
  computed: {
    seletedMaterialRadioDiasbled() {
      // 是否素材替换
      const isReplaceMode = this.uploadIndex > -1

      const states = {
        [MATERIAL_TYPE.IMAGE]: true,
        [MATERIAL_TYPE.VIDEO]: true,
        [MATERIAL_TYPE.LOGO]: true,
        cover: true
      }
      // 只能选择对应的素材类型
      states[this.uploadType] = false

      // 替换时，只能选择对应的素材类型
      if (isReplaceMode) {
        // 如果替换类型为封面，可以将图片radio放开，让用户可以选择图片作为封面
        if (this.uploadType === 'cover') {
          states[MATERIAL_TYPE.IMAGE] = false
        }
      }

      return states
    },
    editState() {
      return this.$route.path.includes('/edit/')
    },
    innerForm() {
      return this.formData.innerForm
    },
    outterForm() {
      return this.formData.outterForm
    },
    formData() {
      return this.$store.getters['Baidu/currTaskParams']
    },
    creativeForm: {
      get() {
        return this.formData.creativeForm
      },
      set(form) {
        this.$store.commit('Baidu/UPDATE_CREATIVE_PARAMS', form)
      }
    },
    disabledptype() {
      return this.creativeForm.scene > 1 && this.creativeForm.ftypes.some((ret) => ret > 2)
    },
    gameId() {
      return this.innerForm.game_id || ''
    },
    media() {
      return Number(this.$store.state.Baidulocal.media)
    },
    opId() {
      return getSession('qianduan_media_account_id')
    }
  },
  methods: {
    changScene(val) {
      const creativeForm = Object.assign({}, this.creativeForm)
      let ftypes = []
      if (val === 2) {
        ftypes = [1, 2, 8, 64]
        this.$set(creativeForm, 'producttypes', 0)
      } else if (val === 4) ftypes = [4]
      this.$set(creativeForm, 'ftypes', ftypes)
      this.creativeForm = creativeForm
    },
    getInitData() {
      const param = { mediaId: this.media, authFlag: 1 }
      Promise.all([adAccount(param), getCaoHuaOpenIds(), adGames({ type: 1 }), getPtomGroupGames(), getSysTag()]).then((data) => {
        const [accounts, operatorData, gameData, gameGroupData, labels] = data
        if (isArray(accounts)) {
          this.accountData = accounts.map((ret) => {
            return { id: ret.id, name: ret.name, children: [], xhr: false, disabled: false }
          })
        }
        if (isArray(operatorData)) this.operatorData = operatorData
        if (isArray(gameData)) this.gameData = gameData
        if (isArray(gameGroupData)) {
          this.gameGroupData = gameGroupData.map((ret) => {
            return {
              id: ret.groupId,
              name: ret.groupName,
              children: ret.gameIds
            }
          })
        }
        if (isArray(labels)) {
          this.labelData = labels.map((ret) => {
            return {
              id: ret.labelId,
              name: ret.content
            }
          })
        }
      })
    },
    changeFtypes(val) {
      const creativeForm = Object.assign({}, this.creativeForm)
      const some = val.some((ret) => ret > 2)
      if (creativeForm.producttypes && some) this.$set(creativeForm, 'producttypes', 0)
      this.creativeForm = creativeForm
    },
    deleteItem({ type, id }) {
      const creativeForm = Object.assign({}, this.creativeForm)
      creativeForm[`${type}Creative`].splice(id, 1)
      this.creativeForm = creativeForm
    },
    // 选择素材上传入口
    selectImage(params) {
      const { name, type, width, height, size, batch, mult, index, smart } = params
      const uploadType = this.switchToType(type)
      this.uploadType = uploadType
      this.uploadWidth = width
      this.uploadHeight = height
      this.uploadName = name
      this.uploadSize = size
      this.uploadSmart = smart || 0
      this.uploadIndex = index
      this.uploadBatch = batch
      this.uploadMult = mult || 1
      // this.uploadModel = true

      let assetType = uploadType
      if (assetType === 'cover') {
        this.selectorProps.videoId = smart
        assetType = 'poster'
      }

      this.selectorProps.form = {
        ...makeSelectorForm(),
        size: `${width}*${height}`,
        media_id: MEDIAS.BAIDU
      }
      this.selectorProps.assetType = MATERIAL_TYPE_ID[assetType]
      this.selectorProps.max = mult || 1
      this.showSelectorModal = true
    },
    switchToType(val) {
      if (val === 'ELEMENT_TYPE_IMAGE') return 'image'
      else if (val === 'ELEMENT_TYPE_VIDEO') return 'video'
      else if (val === 'ELEMENT_TYPE_COVER') return 'cover'
      else if (val === 'ELEMENT_TYPE_LOGO') return 'logo'
      else throw new Error('未知的素材类型')
    },
    addCreative(type) {
      const creativeForm = Object.assign({}, this.creativeForm)
      let param = { name: type }
      if (type === 'video') {
        const mult = 6 - creativeForm.videoCreative.length
        param = Object.assign({}, param, {
          mult,
          batch: true,
          type: 'ELEMENT_TYPE_VIDEO',
          width: 1280,
          height: 720,
          size: 102400
        })
      } else if (type === 'large') {
        const mult = 6 - creativeForm.largeCreative.length
        param = Object.assign({}, param, {
          mult,
          batch: true,
          type: 'ELEMENT_TYPE_IMAGE',
          width: 1140,
          height: 640,
          size: 500
        })
      } else if (type === 'image') {
        const mult = 6 - creativeForm.imageCreative.length
        param = Object.assign({}, param, {
          mult,
          batch: true,
          type: 'ELEMENT_TYPE_IMAGE',
          width: 370,
          height: 245,
          size: 100
        })
      } else if (type === 'group') {
        param = Object.assign({}, param, {
          mult: 3,
          batch: true,
          type: 'ELEMENT_TYPE_IMAGE',
          width: 370,
          height: 245,
          size: 100
        })
      } else if (type === 'logo') {
        param = Object.assign({}, param, {
          mult: 1,
          batch: false,
          type: 'ELEMENT_TYPE_LOGO',
          width: 120,
          height: 120,
          size: 1024
        })
      }
      this.selectImage(param)
      this.creativeForm = creativeForm
    },
    switchType(type) {
      this.uploadType = type
    },
    getElementName(width) {
      let type = ''
      switch (width) {
        case 1280:
          type = 'video'
          break
        case 720:
          type = 'video'
          break
        case 1140:
          type = 'large'
          break
        case 370:
          type = 'image'
          break
        default:
          type = 'image'
          break
      }
      return type
    },
    onSelectorClose() {},
    // 选择素材回调
    uploadFileHandle(data) {
      const creativeForm = Object.assign({}, this.creativeForm)
      if (!isArray(data)) return
      const sourceIds = creativeForm.creativeDetails.map((ret) => ret.photo_id || ret.image_token)
      if (this.uploadType === 'video') {
        // 批量添加视频
        if (this.uploadBatch) {
          data.forEach((ret) => {
            const uploadType = ret.width > 720 ? this.uploadType : 'vertical'
            const creativeElement = deepCopy(this.creativeElements[uploadType])
            const sourceVideo = {
              photo_id: ret.id,
              url: ret.url,
              width: ret.width,
              height: ret.height,
              file_size: ret.size,
              type: this.uploadType
            }
            const sourceImage = {
              image_token: ret.id,
              url: ret.cover_url,
              cover_width: ret.cover_width,
              cover_height: ret.cover_height,
              cover_size: ret.cover_size,
              type: this.uploadType
            }
            const videoIndex = creativeElement.template.findIndex((ret) => ret.element === 'ELEMENT_TYPE_VIDEO')
            const coverIndex = creativeElement.template.findIndex((ret) => ret.element === 'ELEMENT_TYPE_COVER')
            this.$set(creativeElement.template[videoIndex], this.uploadType, ret.id)
            this.$set(creativeElement.template[coverIndex], 'cover', ret.id)
            creativeForm[`${this.uploadType}Creative`].push(creativeElement)
            if (!sourceIds.includes(ret.id)) {
              creativeForm.creativeDetails.push(...[sourceVideo, sourceImage])
            }
          })
        } else if (typeof this.uploadIndex === 'number') {
          // 单个替换
          const item = data.pop()
          const creativeElement = creativeForm[`${this.uploadType}Creative`][this.uploadIndex].template
          const videoIndex = creativeElement.findIndex((ret) => ret.element === 'ELEMENT_TYPE_VIDEO')
          const coverIndex = creativeElement.findIndex((ret) => ret.element === 'ELEMENT_TYPE_COVER')
          const sourceVideo = {
            photo_id: item.id,
            url: item.url,
            width: item.width,
            height: item.height,
            file_size: item.size,
            type: this.uploadType
          }
          const sourceImage = {
            image_token: item.id,
            url: item.cover_url,
            cover_width: item.cover_width,
            cover_height: item.cover_height,
            cover_size: item.cover_size,
            type: this.uploadType
          }
          this.$set(creativeElement[videoIndex], this.uploadType, item.id)
          this.$set(creativeElement[coverIndex], 'cover', item.id)
          if (!sourceIds.includes(item.id)) {
            creativeForm.creativeDetails.push(...[sourceVideo, sourceImage])
          }
        }
      } else if (['cover', 'image'].includes(this.uploadType)) {
        console.log('this.uploadName output: ', this.uploadName)
        console.log('this.uploadType output: ', this.uploadType)
        // 三图
        if (['group', 'image1', 'image2', 'image3'].includes(this.uploadName)) {
          if (typeof this.uploadIndex === 'number') {
            const creativeElement = creativeForm.groupCreative[this.uploadIndex].template[0].children
            data.forEach((ret, i) => {
              const sourceImage = {
                image_token: ret.id,
                url: ret.url,
                width: ret.width,
                height: ret.height,
                file_size: ret.size,
                type: this.uploadType
              }
              this.$set(creativeElement[i], `${this.uploadType}${i + 1}`, ret.id)
              if (!sourceIds.includes(ret.id)) {
                creativeForm.creativeDetails.push(sourceImage)
              }
            })
          } else {
            const creativeElement = deepCopy(this.creativeElements.group)
            data.forEach((ret, i) => {
              const sourceImage = {
                image_token: ret.id,
                url: ret.url,
                width: ret.width,
                height: ret.height,
                file_size: ret.size,
                type: this.uploadType
              }
              this.$set(creativeElement.template[0].children[i], `${this.uploadType}${i + 1}`, ret.id)
              if (!sourceIds.includes(ret.id)) {
                creativeForm.creativeDetails.push(sourceImage)
              }
            })
            creativeForm.groupCreative.push(creativeElement)
          }
        } else if (this.uploadBatch) {
          // 批量添加封面
          data.forEach((ret) => {
            const uploadType = this.getElementName(ret.width)
            console.log('uploadType output: ', uploadType)

            const creativeElement = deepCopy(this.creativeElements[uploadType])
            const sourceImage = {
              image_token: ret.id,
              url: ret.url,
              width: ret.width,
              height: ret.height,
              file_size: ret.size,
              type: this.uploadType
            }
            const imageIndex = creativeElement.template.findIndex((ret) => ret.element === `ELEMENT_TYPE_${this.uploadType.toUpperCase()}`)
            console.log('imageIndex output: ', imageIndex)
            this.$set(creativeElement.template[imageIndex], this.uploadType, ret.id)
            creativeForm[`${uploadType}Creative`].push(creativeElement)
            if (!sourceIds.includes(ret.id)) {
              creativeForm.creativeDetails.push(sourceImage)
            }
          })
        } else if (typeof this.uploadIndex === 'number') {
          const item = data.pop()
          console.log('itemitemitemitem poster output: ', item)
          const uploadType = this.getElementName(item.width)
          const creativeElement = creativeForm[`${uploadType}Creative`][this.uploadIndex].template
          const sourceImage = {
            image_token: item.id,
            url: item.url,
            width: item.width,
            height: item.height,
            file_size: item.size,
            type: this.uploadType
          }
          const imageIndex = creativeElement.findIndex((ret) => ret.element === `ELEMENT_TYPE_${this.uploadType.toUpperCase()}`)
          if (imageIndex > -1) this.$set(creativeElement[imageIndex], this.uploadType, item.id)
          else if (uploadType === 'video') this.$set(creativeElement[1], 'cover', item.id)
          if (!sourceIds.includes(item.id)) {
            creativeForm.creativeDetails.push(sourceImage)
          }
        }
      } else if (['logo'].includes(this.uploadType)) {
        const item = data.pop()
        const sourceImage = {
          id: item.id,
          url: item.url,
          width: item.width,
          height: item.height,
          file_size: item.file_size,
          type: this.uploadType
        }
        this.$set(creativeForm, 'userPortrait', item.id)
        creativeForm.creativeDetails.push(sourceImage)
      }
      this.uploadModel = false
      console.log('creativeFormcreativeForm output: ', creativeForm)

      this.creativeForm = creativeForm
    },
    addTitleList(ret) {
      const creativeForm = Object.assign({}, this.creativeForm)
      const title = ret && ret.docContent
      const val = typeof title === 'string' ? title : ''
      creativeForm.titleList.push({ title: val })
      this.creativeForm = creativeForm
    },
    delTitleList(index) {
      const creativeForm = Object.assign({}, this.creativeForm)
      creativeForm.titleList.splice(index, 1)
      this.creativeForm = creativeForm
    },
    /**
     * @description: 表单校验
     * @return {*} 成功promise.resolve 失败promise.reject
     */
    formValidate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            resolve()
          } else {
            reject(new Error('creative'))
          }
        })
      })
    }
  },
  created() {
    this.getInitData()
  }
}
</script>
<style lang="scss" scoped>
.add-btn {
  margin: 8px 0;
}
</style>
